
export const GET_APPOINTMENTS_TABLE = 'GET_APPOINTMENTS_TABLE'
export const GET_APPOINTMENTS_TABLE_REQUEST = 'GET_APPOINTMENTS_TABLE_REQUEST'
export const GET_APPOINTMENTS_TABLE_SUCCESS = 'GET_APPOINTMENTS_TABLE_SUCCESS'
export const GET_APPOINTMENTS_TABLE_FAILURE = 'GET_APPOINTMENTS_TABLE_FAILURE'